import React, { useState, useEffect, useRef } from "react";
import { paper, Point, Size, Rectangle, Path, Segment, PointText, Group } from "paper";
import Footer from "../../layout/Footer";
import Header from "../../layout/Header";
import { colors } from "../../../helpers/colors";
import { wrapTraceIntoRuns } from "../utils/traceWrap";
import { Button, Modal, Form } from "react-bootstrap";
import DownloadMenu from "../../shared/DownloadMenu";
import { shaftAsf, formatAsf } from "../../shared/asf";
import { openTrueSpace, projectPointFromEvent, hitsLink, drawTrueSpaceNote } from "../../shared/trueSpace";
import { createTraceAlerts, changedTraces } from "../../shared/traceAlerts";
import { useToasts } from "react-toast-notifications";
import { isVerticalJoint, verticalJointTraces, signedDistances } from "../utils/verticalJoint";
import { labelCell } from "../../shared/labelField";

export const SHAFT_CLIP_ALERT =
  "The trace extends beyond the selected shaft depth and has been clipped below that";
const Output = (props) => {
  const { addToast, removeAllToasts } = useToasts();
  let multiplier = 5;
  let log_multiplier = 2;
  let padding = 100;
  let tralength = 80;
  let points = -160;
  let tracedimensions = props.dimensions[0];
  let D = parseInt(tracedimensions.direction);
  let R = parseFloat(tracedimensions.radius) * multiplier;
  // Min depth must keep one-decimal values (e.g. 20.6); parseInt was truncating.
  let Dth = parseFloat(tracedimensions.depth) * multiplier;
  let Dir = parseInt(tracedimensions.dir);
  let Amt = parseInt(tracedimensions.amt);
  let text;
  let Ymax = padding + Dth;
  let TanAmt = Math.tan(toRadians(Amt));
  // let length = 100 * multiplier;
  let i = 0;
  let Arc = (Math.PI * R) / 2;
  console.log("Arc", Arc);
  let ArcFull = Arc * 2;
  // Start and End depth keep one-decimal values, like Min depth.
  let StartDth = parseFloat(tracedimensions.startdepth) * multiplier;
  let EndDth = parseFloat(tracedimensions.enddepth) * multiplier;//Dth + 10 * multiplier + R * 2 * TanAmt;
  let length = EndDth - StartDth;
  let scalearr = [];
  let usrvar = [],
    TanAlpha,
    Pmid,
    Beta,
    ApDir,
    Alpha,
    XP3,
    X1;
  function toRadians(angle) {
    return angle * (Math.PI / 180);
  }
  function toDegree(radian) {
    return radian * (180 / Math.PI);
  }
  const [uservariables, setUserVariables] = useState([]);
  const [show, setShow] = useState(false);
  const [selectedTrace, setSelectedTrace] = useState(false);
  const handleClose = () => setShow(false);
  // Box of the TrueSpace link drawn in the output notes, in project
  // coordinates. Set while drawing; read by the canvas mouse handlers below.
  const trueSpaceLinkBounds = useRef(null);

  const canvasProjectPoint = (e) => {
    const view = paper.view;
    if (!view) return null;
    return projectPointFromEvent(e, e.currentTarget.getBoundingClientRect(), view.viewSize.width);
  };

  const handleCanvasClick = (e) => {
    if (hitsLink(canvasProjectPoint(e), trueSpaceLinkBounds.current)) openTrueSpace();
  };

  const handleCanvasMouseMove = (e) => {
    const over = hitsLink(canvasProjectPoint(e), trueSpaceLinkBounds.current);
    e.currentTarget.style.cursor = over ? "pointer" : "default";
  };

  useEffect(() => {
    if (!props.showdebug) {
      paper.setup("paper-canvas");
      creategraph();
    }
  }, [props.dimensions, props.showdebug]);
  const creategraph = () => {
    paper.project.clear();
    let width = ArcFull * 2 + 850;
    let height = length + 400;
    paper.view.viewSize = new Size(width, height);
    draw();
    paper.view.draw();
  };
  const createScale = () => {
    let Xinit = 4 * Arc + padding;
    for (i = padding; i <= length + padding; i += multiplier * 10) {
      text = new PointText(new Point(Xinit + 15, i));
      text.justification = "center";
      text.fillColor = "black";
      let content = "";
      // if (Dth < length / 2) {
      //   content = (i - padding) / multiplier;
      // } else {
        content = Number(((i - padding + StartDth) / multiplier).toFixed(1));
      // }
      text.content = content;
      scalearr.push([Xinit + 10, i]);
      scalearr.push([Xinit, i]);

      if (i + multiplier * 10 <= length + padding) {
        for (let j = 1; j <= 9; j++) {
          scalearr.push([Xinit, i + multiplier * j]);
          scalearr.push([Xinit + 5, i + multiplier * j]);
          scalearr.push([Xinit, i + multiplier * j]);
        }
        scalearr.push([Xinit, i + multiplier * 10]);
      }
    }
    new Path({
      segments: scalearr,
      strokeColor: "black",
      strokeWidth: 1,
    });
  };
  const createLegend = ({ path, directionarrowline }) => {
    text = new PointText(path.bounds.bottomRight.add([15, 25]));
    text.justification = "left";
    text.fillColor = "black";
    text.content = "Azimuth";
    text = new PointText(directionarrowline.bounds.topLeft.add([0, -15]));
    text.justification = "center";
    text.fillColor = "black";
    text.content = "View Direction N" + String(Math.round(D)).padStart(3, "0") + "\xB0";
    text = new PointText(path.bounds.rightCenter.add([28, -40]));
    text.justification = "left";
    text.fillColor = "black";
    text.content = "Depth";
  };
  const createLog = () => {
    let style = {
      fillColor: "white",
      strokeColor: "black",
      strokeWidth: 1,
    };
    var path = new Path.Rectangle(new Rectangle(new Point(padding, padding), new Size(4 * Arc, length)));
    path.style = style;
    var path1 = new Path.Rectangle(new Rectangle(new Point(padding + Arc, padding), new Size(2 * Arc, length)));
    path1.style = style;

    var path21 = new Path.Circle(path.bounds.bottomCenter.add([0, R + 85]), R);
    path21.style = style;

    var path3 = new Path.Line(path.bounds.topCenter, path21.bounds.bottomCenter);
    path3.strokeColor = "black";
    path3.dashArray = [4, 10];

    var directionarrowline = new Path.Line(path.bounds.topCenter.add([0, -(R / 2 + 10)]), path.bounds.topCenter.add([0, -(R / 2 + 30)]));
    directionarrowline.style = style;
    var directionarrowht = new Path.Line(path.bounds.topCenter.add([0, -(R / 2 + 30)]), path.bounds.topCenter.add([0, -(R / 2 + 20)]));
    directionarrowht.style = style;
    directionarrowht.rotate(45, path.bounds.topCenter.add([0, -(R / 2 + 30)]));
    var directionarrowhb = new Path.Line(path.bounds.topCenter.add([0, -(R / 2 + 30)]), path.bounds.topCenter.add([0, -(R / 2 + 20)]));
    directionarrowhb.style = style;
    directionarrowhb.rotate(315, path.bounds.topCenter.add([0, -(R / 2 + 30)]));



    var path4 = new Path.Arc(path.bounds.bottomRight, path21.bounds.bottomCenter.add([R * 3, -(R * 2)]), path21.bounds.bottomCenter);
    path4.strokeColor = "black";
    path4.dashArray = [2, 2];
    var path5 = new Path.Arc(path.bounds.bottomLeft, path21.bounds.bottomCenter.add([-R * 3, -(R * 2)]), path21.bounds.bottomCenter);
    path5.strokeColor = "black";
    path5.dashArray = [2, 2];
    var path6 = new Path.Arc(path1.bounds.bottomLeft, path21.bounds.leftCenter.add([-25, -R]), path21.bounds.leftCenter);
    path6.strokeColor = "black";
    path6.dashArray = [2, 2];
    var path7 = new Path.Arc(path1.bounds.bottomRight, path21.bounds.rightCenter.add([25, -R]), path21.bounds.rightCenter);
    path7.strokeColor = "black";
    path7.dashArray = [2, 2];
    scalearr = [];
    let counter = 0;
    for (i = padding; i <= 4 * Arc + padding; i += (4 * Arc) / 36) {
      if (counter % 90 == 0) {
        text = new PointText(new Point(i, padding + length + 25));
        text.justification = "center";
        text.fillColor = "black";
        let content = "";
        if (counter === 0 || counter === 360) {
          content = (D > 180 ? D - 180 : D + 180) + "\xB0";
        } else if (counter === 180 || counter === 270 || counter === 90) {
          let degreeToCalculate = D - 180 + counter;
          if(degreeToCalculate < 0){
            degreeToCalculate= 360 + degreeToCalculate;
          }
          if(degreeToCalculate > 360){
            degreeToCalculate =degreeToCalculate - 360;
          }
          content = degreeToCalculate + "\xB0";

        }

        text.content = content;
        text.rotate(90);
        // Rotated labels are tall; anchor each label's top just below the tick
        // marks (which occupy padding+length .. padding+length+10) so the
        // labels extend downward toward the plan circle instead of crossing up
        // into the frame.
        text.bounds.top = padding + length + 14;
      }
      counter += 10;

      scalearr.push([i, padding + length]);
      scalearr.push([[i, padding + length + 10]]);
      scalearr.push([[i, padding + length]]);
      scalearr.push([i + (4 * Arc) / 36, padding + length]);
    }
    new Path({
      segments: scalearr,
      strokeColor: "black",
      strokeWidth: 1,
    });

    // Top distance scale: 0 at centerline, ±πR (meters) at edges
    const topscalearr = [];
    let topCounter = 0;
    for (let j = padding; j <= 4 * Arc + padding; j += (4 * Arc) / 36) {
      if (topCounter % 90 === 0) {
        const distFromCenter = (j - (padding + 2 * Arc)) / multiplier;
        const topText = new PointText(new Point(j, padding - 18));
        topText.justification = "center";
        topText.fillColor = "black";
        topText.content = distFromCenter.toFixed(1).replace(/\.0$/, "") + "m";
        topText.rotate(90);
        // Rotated labels are tall; anchor each label's bottom just above the
        // tick marks (which occupy padding-10 .. padding) so long labels like
        // "-31.4m" extend upward into the free header space instead of crossing
        // down into the frame.
        topText.bounds.bottom = padding - 14;
      }
      topCounter += 10;
      topscalearr.push([j, padding]);
      topscalearr.push([[j, padding - 10]]);
      topscalearr.push([[j, padding]]);
      topscalearr.push([j + (4 * Arc) / 36, padding]);
    }
    new Path({
      segments: topscalearr,
      strokeColor: "black",
      strokeWidth: 1,
    });

    createLegend({ path, directionarrowline });
  };
  const createTrace = () => {
    let style = {
      fillColor: "transparent",
      strokeColor: "black",
      strokeWidth: 1,
    };
    // Log frame geometry — drawn once from dimensions[0]. Traces are clipped
    // to this frame, not to their own startdepth/enddepth copies.
    const logFrameW = 4 * Arc;
    const logFrameH = length;
    const inputRows = [];
    const outputRows = [];
    let geometryInfo = null;
    const alerts = createTraceAlerts();
    props.dimensions.map((dimension, index) => {
      style.strokeColor = colors[index];
      if (index === 0) {
        geometryInfo = {
          viewDir: parseInt(dimension.direction),
          radius: parseFloat(dimension.radius),
          startDepth: dimension.startdepth,
          endDepth: dimension.enddepth,
        };
      }
      if (isVerticalJoint(dimension.amt)) {
        const { traces, alert } = verticalJointTraces({
          D: parseInt(dimension.direction),
          Dir: parseInt(dimension.dir),
          R: parseFloat(dimension.radius),
        });
        const centreX = padding + logFrameW / 2;
        traces.flatMap(signedDistances).forEach((d) => {
          const x = centreX + d * multiplier;
          new Path({ segments: [[x, padding], [x, padding + logFrameH]], style: style });
        });
        alerts.add(alert, index);
        inputRows.push({
          no: String(index + 1),
          label: labelCell(dimension),
          dir: String(parseInt(dimension.dir)),
          amt: "90",
          depth: "-",
          color: colors[index],
        });
        outputRows.push({
          no: String(index + 1),
          label: labelCell(dimension),
          dmax: String(geometryInfo.endDepth),
          tsp: "\u221E",
          asf: formatAsf(shaftAsf(90)),
          color: colors[index],
        });
        return;
      }
      let D = parseInt(dimension.direction);
      let R = parseFloat(dimension.radius) * multiplier;
      // Min depth must keep one-decimal values (e.g. 20.6); parseInt was truncating.
      let Dth = parseFloat(dimension.depth) * multiplier;
      let Dir = parseInt(dimension.dir);
      let Amt = parseInt(dimension.amt);
      let Ymax = padding + Dth;
      let TanAmt = Math.tan(toRadians(Amt));
      // let length = 100 * multiplier;
      let text;
      let i = 0;
      let Arc = (Math.PI * R) / 2;
      console.log("Arc", Arc);
      let ArcFull = Arc * 2;
      let StartDth = parseFloat(dimension.startdepth) * multiplier;
      let EndDth = parseFloat(dimension.enddepth) * multiplier;//Dth + 10 * multiplier + R * 2 * TanAmt;
      let length = EndDth - StartDth;
      let Theta = 0;
      let scalearr = [];
      let usrvar = [],
        TanAlpha,
        Pmid,
        Beta,
        ApDir,
        Alpha,
        XP3,
        X1;
      let traceunion = [];
      let Xmin, Xmax;
      let XPmid = Arc * 2,
        YPmid = padding + R * TanAmt,
        XP2 = padding + Arc,
        YP2 = YPmid,
        XP4 = padding + Arc * 3,
        YP4 = YPmid;
      let diff = D - Dir;
      let toMove = (diff * 4 * Arc) / 360;

      if (Dth < length / 2) {
        YPmid += Dth;
      } else {
        YPmid += Dth - StartDth;
      }

      let XP5 = [],
        YP5 = [],
        H = [],
        XP = [],
        YP = [];

      // 1
      for (let n = 90; n >= 0; n--) {
        H[n] = R * Math.sin(toRadians(n));
        XP5[n] = XP2 - Arc * (n / 90);
        console.log("XP5[n]",n, XP5[n]);
        YP5[n] = YPmid - H[n] * TanAmt;
        if (Xmin) {
          Xmin = Math.min(Xmin, XP5[n]);
        } else {
          Xmin = XP5[n];
        }
        if (Xmax) {
          Xmax = Math.max(Xmax, XP5[n]);
        } else {
          Xmax = XP5[n];
        }
        traceunion.push([XP5[n], YP5[n]]);
      }

      // 2
      for (let n = 0; n <= 90; n++) {
        H[n] = R * Math.sin(toRadians(n));
        XP5[n] = XP2 + Arc * (n / 90);
        YP5[n] = YPmid + H[n] * TanAmt;
        if (Xmin) {
          Xmin = Math.min(Xmin, XP5[n]);
        } else {
          Xmin = XP5[n];
        }
        if (Xmax) {
          Xmax = Math.max(Xmax, XP5[n]);
        } else {
          Xmax = XP5[n];
        }
        traceunion.push([XP5[n], YP5[n]]);
      }

      // 3
      for (let n = 90; n >= 0; n--) {
        H[n] = R * Math.sin(toRadians(n));
        XP5[n] = XP4 - Arc * (n / 90);
        YP5[n] = YPmid + H[n] * TanAmt;
        traceunion.push([XP5[n], YP5[n]]);
      }

      //Left Updip (2nd Quarter)
      for (let n = Theta; n <= 90; n++) {
        H[n] = R * Math.sin(toRadians(n));
        XP5[n] = XP4 + Arc * (n / 90);
        YP5[n] = YPmid - H[n] * TanAmt;
        if (Xmin) {
          Xmin = Math.min(Xmin, XP5[n]);
        } else {
          Xmin = XP5[n];
        }
        if (Xmax) {
          Xmax = Math.max(Xmax, XP5[n]);
        } else {
          Xmax = XP5[n];
        }
        traceunion.push([XP5[n], YP5[n]]);
      }

      //Trace on Right Updip (3rd Quarter)

      // Trace on Right Downdip (4th Quarter)

      // Position the trace at its azimuth by shifting x by -toMove with
      // wrap-around modulo the frame width, starting a new sub-path at each
      // wrap jump. The drawn sub-paths are clipped to the log frame so no
      // trace extends beyond it.
      const frameW = 4 * Arc;
      const runs = wrapTraceIntoRuns(traceunion, padding, frameW, toMove);

      const clipRect = new Path.Rectangle(new Rectangle(new Point(padding, padding), new Size(logFrameW, logFrameH)));
      const tracePaths = runs.map((r) => new Path({ segments: r, style: style }));
      const traceGroup = new Group([clipRect, ...tracePaths]);
      traceGroup.clipped = true;

      usrvar["TanAmt"] = TanAmt.toFixed(1).replace(/\.0$/, "");
      usrvar["Shaft Radius"] = R / multiplier;
      usrvar["View Direction"] = D;
      usrvar["Dth"] = Dth / multiplier;
      console.log("YPmid", R * TanAmt, R * Math.sin(toRadians(90)) * TanAmt + Dth);
      usrvar["P1"] = "(0," + ((R * TanAmt - R * Math.sin(toRadians(90)) * TanAmt + Dth) / multiplier).toFixed(1).replace(/\.0$/, "") + ")";
      usrvar["P2"] = "(" + ((XP2 - padding) / multiplier).toFixed(1).replace(/\.0$/, "") + "," + ((R * TanAmt + Dth) / multiplier).toFixed(1).replace(/\.0$/, "") + ")";
      usrvar["P3"] = `(${((XPmid) / multiplier).toFixed(1).replace(/\.0$/, "")}` + ((R * TanAmt - R * Math.sin(toRadians(90)) * TanAmt) / multiplier).toFixed(1).replace(/\.0$/, "") + ")";
      usrvar["P4"] = "(" + ((XP4-padding) / multiplier).toFixed(1).replace(/\.0$/, "") + "," + ((R * TanAmt + Dth) / multiplier).toFixed(1).replace(/\.0$/, "") + ")";

      usrvar["Bottom of trace"] = ((Dth + R * 2 * TanAmt) / multiplier).toFixed(1).replace(/\.0$/, "");
      usrvar["Dir"] = Dir;
      usrvar["Amt"] = Amt;
      usrvar["Arc"] = (Arc / multiplier).toFixed(1).replace(/\.0$/, "");

      usrvar["Trace Span"] = parseFloat(usrvar["Bottom of trace"] - Dth / multiplier)
        .toFixed(1)
        .replace(/\.0$/, "");
      if (Number(usrvar["Bottom of trace"]) > Number(dimension.enddepth) + 1e-6) {
        alerts.add(SHAFT_CLIP_ALERT, index);
      }

      inputRows.push({
        no: String(index + 1),
        label: labelCell(dimension),
        dir: String(usrvar["Dir"]),
        amt: String(usrvar["Amt"]),
        depth: (Dth / multiplier).toFixed(1).replace(/\.0$/, ""),
        color: colors[index],
      });
      outputRows.push({
        no: String(index + 1),
        label: labelCell(dimension),
        dmax: String(usrvar["Bottom of trace"]),
        tsp: String(usrvar["Trace Span"]),
        asf: formatAsf(shaftAsf(dimension.amt)),
        color: colors[index],
      });

      setUserVariables(usrvar);
    });

    // Only new or edited traces pop up; the rest are already on the output.
    // A redraw of the same traces keeps the pop-ups already showing; any
    // change drops them (and any left over from the input page) first.
    const popUp = changedTraces("shaft-vertical", props.dimensions);
    if (popUp.size) removeAllToasts();
    const alertMessages = alerts.messages(popUp);
    if (alertMessages.length && window.audio) window.audio.play();
    alertMessages.forEach((message) => {
      addToast(message, { appearance: "info" });
    });

    // ---- Tabulated Inputs / Outputs ----
    const drawBorder = (x1, y1, x2, y2) => {
      const p = new Path.Line(new Point(x1, y1), new Point(x2, y2));
      p.strokeColor = "black";
      p.strokeWidth = 0.5;
      return p;
    };
    const cellText = (text, xL, xR, yT, yB, opts = {}) => {
      const t = new PointText(new Point((xL + xR) / 2, (yT + yB) / 2 + 3));
      t.justification = "center";
      t.fillColor = opts.color || "black";
      if (opts.bold) t.fontWeight = "bold";
      t.fontSize = opts.fontSize || 10;
      t.content = text;
      return t;
    };
    const buildCols = (xStart, defs) => {
      let x = xStart;
      return defs.map((d) => {
        const col = { ...d, left: x, right: x + d.width };
        x += d.width;
        return col;
      });
    };
    const tableX = (4 * Arc + padding) + 90;
    const noteLine = (yPos, text, opts = {}) => {
      const n = new PointText(new Point(tableX + (opts.indent || 0), yPos));
      n.justification = "left";
      n.fillColor = "black";
      if (opts.bold) n.fontWeight = "bold";
      n.fontSize = opts.fontSize || 9;
      n.content = text;
      return n;
    };

    let curY = points + padding * 2;

    // ----- Inputs section -----
    const inLabel = new PointText(new Point(tableX, curY));
    inLabel.justification = "left";
    inLabel.fillColor = "black";
    inLabel.fontWeight = "bold";
    inLabel.content = "Inputs:";
    curY += 18;
    if (geometryInfo) {
      const geomText = new PointText(new Point(tableX, curY));
      geomText.justification = "left";
      geomText.fillColor = "black";
      geomText.content =
        "View Direction: N" + String(Math.round(geometryInfo.viewDir)).padStart(3, "0") + "\xB0" +
        "; Shaft Radius: " + geometryInfo.radius +
        "; Start Depth: " + geometryInfo.startDepth +
        "; End Depth: " + geometryInfo.endDepth;
      curY += 20;
    }

    // Input table
    const inColDefs = [
      { key: "no", label: "D.No.", width: 60 },
      { key: "label", label: "Label", width: 60 },
      { key: "dir", label: "DipDir", width: 70 },
      { key: "amt", label: "DipAmt", width: 70 },
      { key: "depth", label: "Min depth", width: 80 },
    ];
    const inCols = buildCols(tableX, inColDefs);
    const inLeftX = inCols[0].left;
    const inRightX = inCols[inCols.length - 1].right;
    const inHeaderRowH = 18;
    const inDataRowH = 18;
    const inHeaderY = curY;
    const inDataY0 = inHeaderY + inHeaderRowH;
    const inTableBottomY = inDataY0 + inDataRowH * inputRows.length;

    inCols.forEach((col) => {
      cellText(col.label, col.left, col.right, inHeaderY, inDataY0, { bold: true });
    });
    inputRows.forEach((row, r) => {
      const yT = inDataY0 + r * inDataRowH;
      const yB = yT + inDataRowH;
      inCols.forEach((col) => {
        cellText(row[col.key] != null ? String(row[col.key]) : "-", col.left, col.right, yT, yB, { color: row.color });
      });
    });
    drawBorder(inLeftX, inHeaderY, inRightX, inHeaderY);
    drawBorder(inLeftX, inTableBottomY, inRightX, inTableBottomY);
    drawBorder(inLeftX, inHeaderY, inLeftX, inTableBottomY);
    drawBorder(inRightX, inHeaderY, inRightX, inTableBottomY);
    inCols.forEach((col, i) => {
      if (i === 0) return;
      drawBorder(col.left, inHeaderY, col.left, inTableBottomY);
    });
    drawBorder(inLeftX, inDataY0, inRightX, inDataY0);
    for (let r = 1; r < inputRows.length; r++) {
      const y = inDataY0 + r * inDataRowH;
      drawBorder(inLeftX, y, inRightX, y);
    }
    curY = inTableBottomY + 14;

    // Input notes
    const inputNotesLabel = noteLine(curY, "Notes:", { bold: true });
    noteLine(curY, " D.No. (Discontinuity number); Label (Discontinuity label); DipDir (Dip direction); DipAmt (Dip amount); Min depth (from collar).", {
      indent: inputNotesLabel.bounds.width + 2,
    });
    curY += 22;

    // ----- Outputs section -----
    const outLabel = new PointText(new Point(tableX, curY));
    outLabel.justification = "left";
    outLabel.fillColor = "black";
    outLabel.fontWeight = "bold";
    outLabel.content = "Outputs:";
    curY += 18;
    if (geometryInfo) {
      const circText = new PointText(new Point(tableX, curY));
      circText.justification = "left";
      circText.fillColor = "black";
      circText.content =
        "Circumference: " + (2 * Math.PI * parseFloat(geometryInfo.radius)).toFixed(1).replace(/\.0$/, "");
      curY += 20;
    }

    const outColDefs = [
      { key: "no", label: "D.No.", width: 55 },
      { key: "label", label: "Label", width: 55 },
      { key: "dmax", label: "MaxDepth", width: 80 },
      { key: "tsp", label: "TSp", width: 55 },
      { key: "asf", label: "Asf", width: 55 },
    ];
    const outCols = buildCols(tableX, outColDefs);
    const outLeftX = outCols[0].left;
    const outRightX = outCols[outCols.length - 1].right;
    const outHeaderRowH = 18;
    const outDataRowH = 18;
    const outHeaderY = curY;
    const outDataY0 = outHeaderY + outHeaderRowH;
    const outTableBottomY = outDataY0 + outDataRowH * outputRows.length;

    outCols.forEach((col) => {
      cellText(col.label, col.left, col.right, outHeaderY, outDataY0, { bold: true });
    });
    outputRows.forEach((row, r) => {
      const yT = outDataY0 + r * outDataRowH;
      const yB = yT + outDataRowH;
      outCols.forEach((col) => {
        const v = row[col.key];
        cellText(v != null ? String(v) : "-", col.left, col.right, yT, yB, { color: row.color });
      });
    });
    drawBorder(outLeftX, outHeaderY, outRightX, outHeaderY);
    drawBorder(outLeftX, outTableBottomY, outRightX, outTableBottomY);
    drawBorder(outLeftX, outHeaderY, outLeftX, outTableBottomY);
    drawBorder(outRightX, outHeaderY, outRightX, outTableBottomY);
    outCols.forEach((col, i) => {
      if (i === 0) return;
      drawBorder(col.left, outHeaderY, col.left, outTableBottomY);
    });
    drawBorder(outLeftX, outDataY0, outRightX, outDataY0);
    for (let r = 1; r < outputRows.length; r++) {
      const y = outDataY0 + r * outDataRowH;
      drawBorder(outLeftX, y, outRightX, y);
    }
    curY = outTableBottomY + 14;

    // The persistence caution reads first, directly under the Outputs table.
    const cautionLabel = noteLine(curY, "Caution:", { bold: true });
    noteLine(curY, " Discontinuity trace span may be evaluated with care in consideration of its persistence.", {
      indent: cautionLabel.bounds.width + 2,
    });
    curY += 16;

    if (alertMessages.length) {
      noteLine(curY, "Alerts:", { bold: true });
      curY += 14;
      alertMessages.forEach((message) => {
        let line = noteLine(curY, "");
        let words = "";
        message.split(/\s+/).forEach((word) => {
          const candidate = words ? words + " " + word : word;
          line.content = candidate;
          if (line.bounds.width > outRightX - tableX && words) {
            line.content = words;
            curY += 12;
            line = noteLine(curY, word);
            words = word;
          } else {
            words = candidate;
          }
        });
        curY += 16;
      });
    }

    // Output notes
    const outputNotesLabel = noteLine(curY, "Notes:", { bold: true });
    noteLine(curY, " D.No. (Discontinuity number); Label (Discontinuity label); MaxDepth (Max depth of trace);", {
      indent: outputNotesLabel.bounds.width + 2,
    });
    curY += 12;
    noteLine(curY, "TSp (Trace span); Asf (Apparent Spacing Factor).", {
      indent: outputNotesLabel.bounds.width + 2,
    });
    curY += 16;

    // Asf usage notes; the last one links to the TrueSpace tool.
    noteLine(curY, "•  Divide True Spacing and/or True Thickness by Apparent Spacing Factor (Asf) to get Apparent Spacing/");
    curY += 12;
    noteLine(curY, "Apparent Thickness along the Shaft.", { indent: 11 });
    curY += 12;
    trueSpaceLinkBounds.current = drawTrueSpaceNote(
      noteLine,
      curY,
      "•  If True Spacing/Thickness not available, get True Spacing/Thickness from this app: ",
      Path
    );
    curY += 16;

    if (paper.view.viewSize.height < curY + 30) {
      paper.view.viewSize = new Size(paper.view.viewSize.width, curY + 30);
    }

  };
  const addTrace = () => {
    props.addtrace();
  };
  const showDeleteTrace = () => {
    setShow(true);
  };
  const deleteTrace = () => {
    props.deletetrace(selectedTrace);
    setShow(false);
  };
  const selectTrace = (e) => {
    // let name = e.target.name;
    let value = e.target.value;
    // console.log(name);
    // console.log(value);
    setSelectedTrace(value);
  };
  const draw = (event) => {
    createScale();
    createLog();
    createTrace();
  };
  return (
    <div id="page">
      <Header onBack={props.showinput} />
      <Footer />
      <div className="page-content header-clear-medium">
        <div className="card card-style contact-form">
          <div className="content">
            <button
              onClick={() => {
                props.showinput();
              }}
              className="btn bg-green-dark mw-2 me-3"
            >
              Edit Input
            </button>
            <button onClick={addTrace} className="btn bg-green-dark me-3">
              Add Trace
            </button>
            {props.tracecount > 0 ? (
              <button onClick={showDeleteTrace} className="btn bg-danger me-3">
                Delete Trace
              </button>
            ) : (
              ""
            )}
            {/* <button onClick={toggleDebug} className="btn bg-green-dark me-3">
              {props.showdebug ? "Graph" : "Values"}
            </button> */}
            <DownloadMenu filename="shaft-plot" screenLabel="Shaft — Plot" feedbackInputs={props.dimensions} />
            <div className="row">
              {/* <div className="col-md-3">
                <table className="table">
                  <tbody>
                    {Object.keys(uservariables).map((uservariable) => (
                      <tr key={uservariable}>
                        <td>{uservariable}</td>
                        <td>{uservariables[uservariable]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div> */}
              <div className="col-md-12 overflow-auto">
                <canvas id="paper-canvas" resize="true" onClick={handleCanvasClick} onMouseMove={handleCanvasMouseMove} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Select trace to delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {props.dimensions.map((dimension, index) => (
            <Form.Check onChange={selectTrace} inline value={index} style={{ color: colors[index] }} label={"Trace " + (index + 1)} name="group1" type="radio" id={index} />
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="danger" onClick={deleteTrace}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Output;
